import { render, staticRenderFns } from "./orderFee.vue?vue&type=template&id=ea4d925a&"
import script from "./orderFee.vue?vue&type=script&lang=js&"
export * from "./orderFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports